import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadVehiclesByIdFailed, loadVehiclesByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_MDS_URL } from '../../../configs';

export default function* loadVehiclesById(action) {
  try {
    const url = `${BACKEND_MDS_URL}/agency/vehicles/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true, {
      Accept: 'application/json;version=1.2.0',
    });
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadVehiclesByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadVehiclesByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadVehiclesByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
